import { render, staticRenderFns } from "./VProjectProposal.vue?vue&type=template&id=2879796b&"
import script from "./VProjectProposal.vue?vue&type=script&lang=js&"
export * from "./VProjectProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports